import { useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'

const useIdleUser = () => {
  const [isIdle, setIsIdle] = useState(false)

  useIdleTimer({
    timeout: 1000 * 60 * 60, // 1 hour
    onIdle: () => setIsIdle(true),
    onActive: () => setIsIdle(false),
    debounce: 500
  })

  return { isIdle }
}

export default useIdleUser
